<div>
    <h5>Esta ação removerá o App {{data.accountantName}} da lista de aplicativos pendentes e iniciará a configuração em modo rascunho, deseja continuar?</h5>
    <mat-dialog-actions class="d-flex gap-2">
        <button type="button" (click)="onConfirm()" class="btn btn-primary">Confirmar</button>
        <button type="button" (click)="onDismiss()" class="btn btn-danger">Cancelar</button>
    </mat-dialog-actions>
</div>